<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  components: {},
  mounted() {
    console.log('医知检PC端欢迎你 == 2025-04-29 10:26');
  },
  created() {
    // console.log('appvue == created');
  },
  beforeDestroy(){
    // console.log("appvue  销坏") 
  },
  methods: {}
};
</script>

<style>
@import './assets/iconfont/iconfont.css';
@import './assets/css/main.css';
@import './assets/css/color-dark.css'; /*深色主题*/
@import './assets/css/common.css';
/*@import "./assets/css/theme-green/color-green.css";   浅绿色主题*/
</style>